import React from 'react'
import { Container, Image } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import '../Assets/dashboard.css'
import imgMobile from '../Assets/2021122_FIC2022-BANNER-FOR-WEB-SQ-Click.gif'
import imgDesktop from '../Assets/2021122_FIC2022-BANNER-FOR-WEB-Click.gif'
import * as ajax from '../Utilities/ajax'

const BANNER_IDX = parseInt((document.getElementById("REACT_APP_BANNER_IDX") as HTMLInputElement).value || "-1")
const BANNER_LINK = [
  "https://foic2022.com/?session=ZZwbDafJhRRIbkoNLxGT3wwm2ch6EH", // 2022-01-17 17:00
  "https://foic2022.com/?session=Z7cEgpXSSANvb3phBeXwhHdwAZjaVY", // 2022-01-19 17:00
  "https://foic2022.com/?session=6dvrBf65EEHNqMVvPjCEiF9oA3WPEW", // 2022-01-24 17:00
  "https://foic2022.com/?session=8sxw5WDwcoEeSUky5moTidSx3YjFml", // 2022-01-26 17:00
  "https://foic2022.com/?session=BPB7mrM1eXSERCKROntZr7OEy79cmQ", // 2022-01-31 17:00
  "https://foic2022.com/?session=dcYaw1xgixjWwx2oLIxM4oNRLfkNSZ", // 2022-02-02 17:00
  "https://foic2022.com/?session=sqYG1BGKofOX8WeEIJ95z2E0zSz7AJ", // 2022-02-07 17:00
  "https://foic2022.com/?session=1KRsFAboTA5xP518ddPMBWETyZupYs", // 2022-02-09 17:00
]

export const Dashboard = ({ canViewMacroEco, canViewReport, canViewVideo, isAdmin: _isAdmin }) => {
  let history = useHistory()

  const handlePush = async (page: "macroeco" | "publication" | "video") => {
    if (page === "macroeco") {
      history.push("macroeco")
    }
    else if (page === "video") {
      await ajax.post("/banner/log", {})
      history.push("video")
    }
    else if (page === "publication") {
      history.push("publication")
    }
  }

  const handleBannerClick = async () => {
    await ajax.post("/banner/log", {})
    window.location.href = BANNER_LINK[BANNER_IDX]
  }

  return (
    <>
      {BANNER_LINK[BANNER_IDX] &&
        <Container className="dashboard-container-image">
          <a href="#" onClick={() => handleBannerClick()}> {/* eslint-disable-line */}
            <Image src={imgMobile} className="img-dashboard-banner-mb" />
            <Image src={imgDesktop} className="img-dashboard-banner" />
          </a>
        </Container>
      }
      <Container fluid className="dashboard-container">
        <div className={_isAdmin ? "cards" : "cards admin"}>
          {canViewReport && (
            <div className="img-cards" onClick={() => handlePush("publication")}>
              <Image className="img-card" src="/card-equity.png" />
            </div>
          )}
          {canViewMacroEco && (
            <div className="mt25 img-cards" onClick={() => handlePush("macroeco")}>
              <Image className="img-card" src="/card-macroeconomics.png" />
            </div>
          )}
          {canViewVideo && (
            <div className="mt25 img-cards" onClick={() => handlePush("video")}>
              <Image className="img-card" src="/card-record.png" />
            </div>
          )}
          {_isAdmin && (
            <div className="mt25 img-cards set" onClick={() => history.push("/")}>
              <Image className="img-card" src="/card-setting.png" />
            </div>
          )}
        </div>
      </Container>
    </>
  )
}
